"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatter = exports.FormatterStyle = exports.LOCALE_SETTINGS = exports.CurrencySymbolPos = void 0;
const lodash_1 = require("lodash");
const global_constants_1 = require("@contentsquare/global-constants");
var CurrencySymbolPos;
(function (CurrencySymbolPos) {
    CurrencySymbolPos["Prefix"] = "prefix";
    CurrencySymbolPos["Suffix"] = "suffix";
})(CurrencySymbolPos = exports.CurrencySymbolPos || (exports.CurrencySymbolPos = {}));
exports.LOCALE_SETTINGS = {
    [global_constants_1.SupportedLocale.En]: {
        decimalSeparator: '.',
        thousandSeparator: ',',
        percentSuffix: '%',
        currencySymbolPos: CurrencySymbolPos.Prefix,
    },
    [global_constants_1.SupportedLocale.Gb]: {
        decimalSeparator: '.',
        thousandSeparator: ',',
        percentSuffix: '%',
        currencySymbolPos: CurrencySymbolPos.Prefix,
    },
    [global_constants_1.SupportedLocale.Us]: {
        decimalSeparator: '.',
        thousandSeparator: ',',
        percentSuffix: '%',
        currencySymbolPos: CurrencySymbolPos.Prefix,
    },
    [global_constants_1.SupportedLocale.Fr]: {
        decimalSeparator: ',',
        thousandSeparator: ' ',
        percentSuffix: ' %',
        currencySymbolPos: CurrencySymbolPos.Suffix,
    },
    [global_constants_1.SupportedLocale.De]: {
        decimalSeparator: ',',
        thousandSeparator: '.',
        percentSuffix: ' %',
        currencySymbolPos: CurrencySymbolPos.Suffix,
    },
    [global_constants_1.SupportedLocale.Es]: {
        decimalSeparator: ',',
        thousandSeparator: '.',
        percentSuffix: ' %',
        currencySymbolPos: CurrencySymbolPos.Suffix,
    },
    [global_constants_1.SupportedLocale.Ja]: {
        decimalSeparator: '.',
        thousandSeparator: ',',
        percentSuffix: ' %',
        currencySymbolPos: CurrencySymbolPos.Prefix,
    },
    [global_constants_1.SupportedLocale.It]: {
        decimalSeparator: ',',
        thousandSeparator: ' ',
        percentSuffix: ' %',
        currencySymbolPos: CurrencySymbolPos.Suffix,
    },
};
var FormatterStyle;
(function (FormatterStyle) {
    FormatterStyle["Decimal"] = "decimal";
    FormatterStyle["Percent"] = "percent";
    FormatterStyle["Currency"] = "currency";
})(FormatterStyle = exports.FormatterStyle || (exports.FormatterStyle = {}));
class NumberFormatter {
    constructor(locale, config) {
        this.locale = locale;
        this.config = config;
    }
    format(value) {
        const { style, currency, minimumFractionDigits, maximumFractionDigits } = this.config;
        if ((0, lodash_1.isNumber)(minimumFractionDigits) &&
            (0, lodash_1.isNumber)(maximumFractionDigits) &&
            maximumFractionDigits < minimumFractionDigits) {
            throw new RangeError(`minimumFractionDigits ${minimumFractionDigits} should be smaller than maximumFractionDigits ${maximumFractionDigits}`);
        }
        // if no minimumFraction defined, the number will be automatically round up
        const formattedValueStr = Number(value).toFixed(minimumFractionDigits || 0);
        switch (style) {
            case 'decimal':
                return this.convertLocaleNumber(formattedValueStr);
            case 'percent':
                return this.convertLocalePercent(formattedValueStr);
            case 'currency':
                return this.convertLocaleCurrency(formattedValueStr, currency);
            default:
                return this.convertLocaleNumber(formattedValueStr);
        }
    }
    convertLocaleNumber(value) {
        // Node/chrome has default support of en locale
        const enNumber = parseFloat(value).toLocaleString('en');
        if (this.locale.startsWith('en')) {
            return enNumber;
        }
        const { decimalSeparator: enDecimalSeparator, thousandSeparator: enThousandSeparator } = exports.LOCALE_SETTINGS[global_constants_1.SupportedLocale.En];
        const localeSettings = exports.LOCALE_SETTINGS[this.locale];
        if (!localeSettings) {
            throw new RangeError(`${this.locale} is not supported yet`);
        }
        const { decimalSeparator, thousandSeparator } = localeSettings;
        return enNumber
            .split('')
            .map((s) => {
            if (s === enDecimalSeparator) {
                return decimalSeparator;
            }
            if (s === enThousandSeparator) {
                return thousandSeparator;
            }
            return s;
        })
            .join('');
    }
    convertLocalePercent(value) {
        // percent is not identical to Intl Api (it will not multiply by 100 before convert)
        const val = this.convertLocaleNumber(value);
        const { percentSuffix } = exports.LOCALE_SETTINGS[this.locale];
        return `${val}${percentSuffix}`;
    }
    convertLocaleCurrency(value, currencyCode) {
        if (!currencyCode) {
            throw new TypeError('Currency code is required with currency style');
        }
        const val = this.convertLocaleNumber(value);
        const { symbol } = global_constants_1.CURRENCIES.find((currency) => currency.code === currencyCode);
        const { currencySymbolPos } = exports.LOCALE_SETTINGS[this.locale];
        if (currencySymbolPos === CurrencySymbolPos.Suffix) {
            return `${val} ${symbol}`;
        }
        return `${symbol}${val}`;
    }
}
exports.NumberFormatter = NumberFormatter;
//# sourceMappingURL=number-formatter.js.map